import React, {useEffect, useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {MenuItem} from '@components';
import * as mainService from '@app/services/mainService';
import {loadMenu} from '@store/reducers/auth';

const MenuSidebar = () => {
    const dispatch = useDispatch();
    const [myMenu, setMyMenu] = useState([]);
    const isMountedRef = useRef(true);

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const myMenuX = await mainService.showLeftMenu();

                if (isMountedRef.current && myMenuX) {
                    dispatch(loadMenu(myMenuX));
                    const rawmyMenu = myMenuX.map((menuItem) => (
                        <MenuItem key={menuItem.id} menuItem={menuItem} />
                    ));
                    setMyMenu(rawmyMenu);
                }
            } catch (error) {
                console.error('Error fetching menu:', error);
            }
        };

        fetchMenu();

        return () => {
            isMountedRef.current = false;
        };
    }, [dispatch]);

    if (!myMenu || myMenu.length === 0) {
        return null;
    }

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <Link to="/" className="brand-link">
                <img
                    src={process.env.PUBLIC_URL + "/img/flower.png"}
                    alt="AdminLTE Logo"
                    className="brand-image img-circle elevation-3"
                    style={{opacity: '.8'}}
                />
                <span className="brand-text font-weight-light">HOÀNG CƠ ĐẠI ĐẠO</span>
            </Link>
            <div className="sidebar">
                <nav className="mt-2" style={{overflowY: 'hidden'}}>
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        {myMenu}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;